import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';

type SocialMediaNetwork = {
    name: string;
    url: string;
};

export default function SocialMediaSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.status === 'passed' &&
                    result.social_media_networks.map((network: SocialMediaNetwork) => (
                        <a
                            href={network.url}
                            key={network.name}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {network.name}&nbsp;
                        </a>
                    ))}

                {result.status !== 'passed' && result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) =>
                            result.status === 'passed' &&
                            result.social_media_networks.map((socialMedia: SocialMediaNetwork) => (
                                <a
                                    href={socialMedia.url}
                                    key={socialMedia.name}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {socialMedia.name}&nbsp;
                                </a>
                            ))
                        }
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
